var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsCheckSmallRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 13.6L15.9 7.69999C16.0833 7.51665 16.3167 7.42499 16.6 7.42499C16.8833 7.42499 17.1167 7.51665 17.3 7.69999C17.4833 7.88332 17.575 8.11665 17.575 8.39999C17.575 8.68332 17.4833 8.91665 17.3 9.09999L10.7 15.7C10.5 15.9 10.2667 16 9.99999 16C9.73332 16 9.49999 15.9 9.29999 15.7L6.69999 13.1C6.51665 12.9167 6.42499 12.6833 6.42499 12.4C6.42499 12.1167 6.51665 11.8833 6.69999 11.7C6.88332 11.5167 7.11665 11.425 7.39999 11.425C7.68332 11.425 7.91665 11.5167 8.09999 11.7L9.99999 13.6Z",
    fill: "#3F3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsCheckSmallRounded);
export default __webpack_public_path__ + "static/media/material-symbols_check-small-rounded.7a18d55c3cdcbd4d539c67b4f2636b31.svg";
export { ForwardRef as ReactComponent };